<template>
  <div class="hello">
    Hi {{user.name || user.email}}
    <div class="container">
      <div class="bigbutton" @click="goto('reservationadmin')">
        Reservations
      </div>
      <div class="bigbutton" @click="goto('MasksList')">
        View Masks
      </div>
      <div class="bigbutton" @click="showNewMask = true" v-if="!showNewMask">
        Add New Mask
      </div>
      <div class="bigbutton" @click="goto('setup')">
        Maintenance Message
      </div>
      <div class="bigbutton" @click="goto('FAQ')">
        Edit FAQs
      </div>
      <div id="new-mask-container" v-if="showNewMask">
        <span v-if="submitted && !name" class="error">Wao! At least put a name!</span>
        <input id="name" v-model="name" type="text" placeholder="Name of mask">
        <div class="bigbutton add" @click="add()">
          Add
        </div>
        <div class="bigbutton cancel" @click="cancel()">
          Cancel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {auth, db} from '../firebase/firebaseConfig'
import Helper from './mixins/HelperFunctions.js'
export default {
  mixins: [Helper],
  name: 'Admin',
  props: {
    msg: String
  },
  mounted() {},
  data: function (){
    return {
      name: '',
      showNewMask: false,
      submitted: false
    }
  },
  methods: {
    add: function() {
      this.submitted = true
      //number of masks?
      let vm = this
      // // Add a new document with a generated id.
      let oroId = vm.masks.length + 1
      if(vm.name) {
        db.collection(this.maskPath).add({
          name: vm.name,
          description: '',
          available: 0,
          id: oroId,
          image: this.maskPath + '/oro.jpg',
          thumb: this.maskPath + '/oro.jpg',
          created: new Date()
        }).then(() => {
          this.$router.push({name: 'editmask', params: {id: oroId}})
        });
      }

    },
    cancel: function() {
      this.name = ''
      this.showNewMask = false
    },
    login: function() {
      auth.signInWithEmailAndPassword(this.email, this.password).then(
        function(user) {
          console.log('yay', user)
        },
        function(err) {
          console.log('aww ', err)
        }
      )
    }
  },
  computed: {
    masks () {
      return this.$store.getters.getMasks
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.error {
  margin: 5px 0 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 5px 0;
  display: block;
  font-weight: bold;
  background: red;
  color: white;
}
.container {
  width: 300px;
  margin: auto;
}
.bigbutton {
  margin: 10px auto;
  border-radius: 5px;
  display: block;
  padding: 20px;
  background: #e9c46a;
  color: #264653;
  font-weight: bold;
  box-shadow: 0 8px 6px -6px black;
  &.add {
    background: white;
    color: green;
  }
  &.cancel {
    color: red;
    background: white;
  }
}
#new-mask-container {
  width: 300px;
  display: inline-block;
}
input {
  display: inline-block;
  padding: 15px 0 15px 10px;
  border: none;
  outline: none;
  font-size: 24px;
  &:focus {
    border: none;
    color: #772e25;
  }
}
button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}

</style>
